import { AfterViewInit, Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-table-component',
  templateUrl: 'table.component.html',
  styleUrls: ['table.component.css'],
})
export class TableComponent implements OnInit, AfterViewInit {

  @Input() ds: any;
  @ViewChild('aSort') sort: MatSort;

  displayedColumns: string[] = ['uploadReport', 'status', 'uploaded', 'fileName'];

  constructor(public dialog: MatDialog) {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.ds.sort = this.sort;
  }

  showUploadReport(uploadReport: string): void {
    this.dialog.open(DialogDataUploadReportComponent, {
      data: {
        text: uploadReport
      },
      width: '1000px',
      maxWidth: '100vw',
    });
  }

}

@Component({
  selector: 'app-dialog-data-upload-report',
  templateUrl: 'dialog-data-upload-report.component.html',
})
export class DialogDataUploadReportComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {}
}
export interface DialogData {
  text: string;
}
